import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiSelectPeriodModule } from '@fi-shared/fi-select-period';
import { FiEditPublicationComponent } from './edit-publication.component';
import { FiDatePickerModule } from '@fi-shared/fi-date-picker';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatRadioModule,
        FiAppTextSharedModule,
        FiSelectPeriodModule,
        FiDatePickerModule,
    ],
    declarations: [FiEditPublicationComponent],
    exports: [FiEditPublicationComponent],
})
export class FiEditPublicationModule {}
